<template>
  <b-container>

    <!-- <b-form @submut.prevent="sendNotification"> -->
      <b-row class="m-3">
        <b-col cols="3"></b-col>
        <b-col cols="3">
          <b-button @click="exportURL" v-b-tooltip.hover.right="'La copie se trouve dans le presse-papier.'">Exporter URL</b-button>
        </b-col>
        <b-col cols="3">
          <b-form-checkbox v-model="isProd" :value="true" :unchecked-value="false">Production</b-form-checkbox>
        </b-col>
      </b-row>
      
      <b-card>
      <b-row class="m-3">
        <b-col cols="6">
          <span>Quelle est la somme de sept et de trois ? Donnez la réponse avec des chiffres.</span>
        </b-col>
        <b-col cols="6">
          <b-form-input v-model="antiBotThing"></b-form-input>
        </b-col>
        
      </b-row>
    </b-card>

      <b-form-group label="Auth token">
        <b-form-textarea v-model="token" rows="2"/>
      </b-form-group>

      <b-form-group label="Server id">
        <b-form-input v-model="serverId"/>
      </b-form-group>

      <b-form-group label="Recipient">
        <b-form-input v-model="recipient"/>

      </b-form-group>

      

      <b-form-group v-show="qrCodeVisible" class="my-3">
        
        <div class="card m-auto" style="width: 16rem;">
            <!-- <img class="card-img-top" :src="qrCodeLink" alt="QR code pour se connecter à myTamatNotif"/> -->
            <canvas id="qr-code-canvas"/>
            <div class="card-body">
                <p>Server id: {{ serverId }}</p> <p>Recipient: {{ recipient }} </p>
                <!-- <p><b-button @click="saveQrCode">Save</b-button></p> -->
                <p><a :href="qrCodeURL" target="_blank" download="image.png"><b-button>Save</b-button></a></p>
            </div>
        </div>
      </b-form-group>

      <div>
      <b-form-group label="Notification type" class="my-3">
        <b-form-radio-group v-model="selectedNotificationType" :options="notificationTypeOptions" value-field="item" text-field="name" inline/>

      </b-form-group>

      <b-form-group label="Notification id" class="my-3">
        <b-form-input v-model="notificationId"/> 
        <b-button @click="notificationId = generateRandomly()">Generate new value</b-button>
      </b-form-group>
      </div>

      <b-form-group label="Priority" class="my-3">
        <b-form-input type="number" min="1000" max="10000" v-model="priority"/> 
      </b-form-group>

      <b-form-group label="Title">
        <b-form-input v-model="title"/>

        
      </b-form-group>

      <b-form-group label="Body">
        <b-form-input v-model="body"/>

        
      </b-form-group>

      <b-form-group label="Actions">
        <b-form-input v-model="newAction"/>
        <b-button class="m-3" @click="addAction" id="add-action-tooltip" v-b-tooltip.hover.leftbottom="'The action entry must not be void.'">Add action</b-button>
        <!-- <b-tooltip target="add-action-tooltip" triggers="hover" placement="bottom">
          The action entry must not be void.
        </b-tooltip> -->
        <b-button class="m-3" @click="removeAction">Remove last action</b-button>
        <ul>
          <li v-for="(action, index) in actions" :key="'action-'+index">
            <b-form-input disabled v-model="actions[index].label"/>
          </li>
        </ul>




      </b-form-group>

      <b-form-group label="GPS coordinates">
        <b-form-input v-model="locationGPS"/>
      </b-form-group>

      <b-form-group label="Location description">
        <b-form-input v-model="locationDescription"/>
      </b-form-group>

      <b-form-group label="Phone number to call">
        <b-form-input v-model="phoneNumberToCall"/>
      </b-form-group>

      <!-- <b-button @click="sendNotification" class="mx-2">Send connection info</b-button> -->
        <b-button :disabled="!canSendNotification" @click="sendNotification(serverId, title, body, actions, 
        [recipient], selectedNotificationType, phoneNumberToCall, locationGPS, locationDescription, token)" 
        class="mx-2 my-3">Send notification</b-button>
        <!-- <b-button @click="showQRCode" class="mx-2">Show QR code for authentification</b-button> -->
    <!-- </b-form> -->

    

  </b-container>
</template>

<script>
var QRCode = require('qrcode');
// import QRCode from 'qrcode';

import {sendNotificationRequest} from '../utils/api_notification';
  
export default {
  name: 'ContactForm',
  props: {

  },
  data: function() {
    return {
      serverId: '',
      token: '',
      recipient: '',
      title: 'Title for test',
      body: 'Body for test',
      selectedNotificationType: 'urgent',
      notificationTypeOptions: [
        {item: "normal", name: "Normal"},
        {item: "high", name: "High"},
        {item: "urgent", name: "Urgent"},
        {item: "critical", name: "Critical"},
      ],
      newAction: '',
      locationGPS: '',
      locationDescription: '',
      phoneNumberToCall: '',
      actions: [{label: "Yes", value: "1"}, {label: "No", value: "0"}],
      qrCodeVisible: false,
      qrCodeURL: '',
      notificationId: 0,
      priority: 5000,
      isProd: true,
      antiBotThing: ''
    }
  },
  mounted() {
    // ?serverId=b3KgnbM9DYqwYGYt4RXc&recipient=arnaud.penfornis%40gmail.com&title=Pause&body=Pause&token=7DSXEzfTCRLIaY2eFW3S9aEKkFkUoBcFOWOyAunqsmzBFY4aq3ylF9JDrVb5K0xVOi4QNb6sQieU8FsY8DaveA8kcTqxZv3yskrZhxmrVb4DnfJDSx4TsGWp3oeIXr82sDlWyoa8eaxMHVrDqPHgftGnLBBW6ES31rBsrVScHugx4Ce32GRcn8PPxejyKi8WUdwy1uELI2RhUeM8tc7fEdtM698gOVP4K4o0dDNoe0dby8OhcRYAaotNub60HeRsL3a5wGoukOcOTc1EQHQusmGWlofdQJ10qUgiGcOdJqdCGWd5CYcpJS26MZhdgEufXmaXpEIVvpamc048MvdSUEYd3YOkQgnlv3MHTsTSOFY0kDMkKA4LJm7f9SVTP5acW4i9ZtD0AbwPGzKxyOhGv1IcARg1FyDtacp8Ys1pY1HuO85ZuwUiE7vzOLFw6a1A9pewbUe9wk2XaBatxysShS54zJFuGEr6RESQXf0PAeF5QD2qF6F27gYVd1yoQYEVgkLD4hUmQN1qJptTzli8LSQu7KhsGPu8rtUtllmvmQUtkz1KjbCGd6RL4Z1rbf7PkGS1cWO8vj1IQ1PUNo6gYLlMIkCJ0RD4oG7uOttyG02LqbcmN35TUj3FNW6DixT5XIH4WseaVSTgfYTTO3MFLh3PE73fViwVrMKTVSzjplHbRenAldaHWtqmu1vYuzkTdekJZcIxPnikxYM420qyQ1IlUNbMNJalTOevisd24pqvsEYA8haRVWdNbKYMAO6F737Vm6hwkvB3ssN2k7LKmp60hucihbPb9iqnrj20NjicXumNqlBOem54kBBgH1KYPwl2g83AHgcqn4Qv7a6UUIj778Pgkt8KxmsKhYX7W7VQqHZr4Vlyaf3DVQCVQ5Ry5J5kjW3XEse0shQhm5xDJxH372ZNSCTmtfXGl8psEQGkblPn1ukdVyhuw4mpMykNhh6G6L3HG0ygPxymT31PHANmPt9iWxtcY0wgiZIBGMxIQ3kyB3UWL6Ba4M5XP32A8MH2GzclGvOQ5MRVBtlBqIHgYz1mQybPyvgvFI7PR9yPjBwppKN67w8P2CxXxNYtGsQeNWow5WSwey2BRQUEeShfzqj0pEt6IO6L6WeyqJ9GRdmHnnqtoyebdU6PwAEBvBQGEnrSMTcLk1NQyWGHVrZvPG4upwGxeMh4YAY56XTnJQ505Wf1xezwtZouLh7wQ2jo817bOqACWEnzowaRloLuCCQP1hYn4HwAPA0g8QWLRcKcSTUCFAbB2qtr9hx6sjA4JGMFZsYE0d6tGvPWTQ1TbZ3TAbuXRmxtQiFgw3epLhsJaCEcVetfKJ1qOwPnIvD25B6lml7yXFkdDNWLRmjfyjPqbW152o3EVq8J2GVyQw5PxvIToA3ut2JAq0nLgU1zPBZnwyPWy2skImE7rSdolKZYt2EQMGTTZRgOUv2UgvI1rAKAWSanhfU37kUtqOFFnbhu8rrXLCdUuJFDugYKh4EksTXZjyMVisguV4O0Lic66SqQHoxY89lnC4atY4DT1pd5EXLt0EPYO7VIQ6OXuIxLS6v2pHyQ03AaMSNbNhsMrwiM1as1sIFSsWdHV81UnUxhSK9ajqI7NrSjpaFB6pDifvK1VlJ4KsiPQEmCKIyocCIZBXxFqrjPWLbtifCdtBOMbilxLI1djIaeziI6Y84xDpqGPtG4J3ZNfOGzCKA4NUQu2IDmS9azg6VFky2MNEb4BVj3XqAArezAYzyJwRlFw9OSaAR4ipYcV3nFI9gJLTO5sQ7pFUdPFIRYRN71BSWdBbICGUPXXRALKQvpn7g0LUjpHS70ldh4xMvCvVG0ntUpqizZxCjvCy6lbZcvt3HeVzvd6OODslGZT8c3aA1vWVrt5bQhAEhDkXhrgAw0EhYWZItfzPNJnq8oc6LYCtq7vYCeYJE2NuiQZUaADkAnLhHCeqZs1U91Ot9TNR21NS7aFv4czxEbLf5yuRINdLvnIDx87EA8zAxMkD6SjTVHPu8LeB97bcokNa5pUoGvztkiteCjLCHHF74M
    if(this.$route.query.token) {
      this.token = this.$route.query.token;
    }
    if(this.$route.query.serverId) {
      this.serverId = this.$route.query.serverId;
    }
    if(this.$route.query.recipient) {
      this.recipient = this.$route.query.recipient;
    }
    if(this.$route.query.title) {
      this.title = this.$route.query.title;
    }
    if(this.$route.query.body) {
      this.body = this.$route.query.body;
    }
    this.notificationId = this.generateRandomly();
    if(this.$route.query.notificationId) {
      this.notificationId = this.$route.query.notificationId;
    }
    if(this.$route.query.ringType) {
      this.selectedNotificationType = this.$route.query.ringType;
    }
    if(this.$route.query.isProd) {
      this.isProd = this.$route.query.isProd !== "false";
    }
    if(this.$route.query.locationGPS) {
      this.locationGPS = this.$route.query.locationGPS;
    }
    if(this.$route.query.locationDescription) {
      this.locationDescription = this.$route.query.locationDescription;
    }
    if(this.$route.query.phoneNumberToCall) {
      this.phoneNumberToCall = this.$route.query.phoneNumberToCall;
    }
    if(this.$route.query.actions) {
      this.actions = this.$route.query.actions;
    }
  },
  methods: {
    sendNotification(serverId, title, body, actions, recipients, notificationType, phoneNumberToCall, locationGPS, locationDescription, token) {
      if(this.serverId.length > 0) {
        sendNotificationRequest(serverId, title, body, actions, recipients, notificationType.toLowerCase(), token, phoneNumberToCall, locationGPS, locationDescription, this.isProd).then(
          (response) => {
            console.log(response);
          }
        );
      }
    },
    // sendConnectionInfo() {
      
    // },
    // showQRCode(serverId, recipient) {
    //   window.open(
    //     +"server_id="+serverId+"&recipient="+recipient,
    //             "width=1000,height=600,location=no,menubar=no," +
    //     "status=no,resizable=yes,scrollbars=yes");
    // },
    addAction() {
      if(this.newAction.length > 0) {
        this.actions.push({
          label: this.newAction,
          value: this.newAction
        });
        this.newAction = "";
      }
    },
    removeAction() {
      if(this.actions.length > 0) {
        this.actions.pop();
      }
    },
    exportURL() {
      let href = location.href;
      let splittedURL = href.split("?");
      let url = "";
      if(splittedURL.length === 1) {
        url = href;
      } else if (splittedURL.length === 2) {
        url = splittedURL[0];
      }

      navigator.permissions.query({name: 'clipboard-write'}).then(result => {
        if(result.state === "granted" || result.state === "prompt")  {
          navigator.clipboard.writeText(url+this.queryURL);
        } else {
          console.log("not granted");
        }
      }).catch(() => {
        // console.log(reason);
        navigator.clipboard.writeText(url+this.queryURL);
      } );
    },
    updateQRCode(qrCode) {
      let canvas = document.getElementById('qr-code-canvas');
      const that = this;
      QRCode.toCanvas(canvas, qrCode, {}, function(error) {
        if(error) {
          console.error(error);
        } else {
          console.log("success");
          that.qrCodeURL = document.getElementById('qr-code-canvas').toDataURL();
        }
      });
    },
    saveQrCode() {
      console.log(document.getElementById('qr-code-canvas').toDataURL());
      console.log(QRCode.toFile);
      QRCode.toFile('./myTamatNotif-qrcode.jpg', this.qrCodeData, {}, function(error) {
        if(error) {
          console.error(error);
        } else {
          console.log("success");
        }
      })
    },
    generateRandomly() {
      return Math.floor(Math.random() * 10000);
    },
  },
  computed: {
    qrCodeValid: function() {
      return this.recipient.length > 0 && this.serverId.length > 0;
    },
    qrCodeData: function() {
      return `server:${this.serverId};recipient:${this.recipient}`;
    },
    qrCodeLink: function() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${this.qrCodeData}`;
    },
    queryURL: function() {
      let queries = {};
      if(this.title.length > 0) {
        queries.title = this.title;
      }
      if(this.body.length > 0) {
        queries.body = this.body;
      }
      if(this.recipient.length > 0) {
        queries.recipient = this.recipient;
      }
      if(this.serverId.length > 0) {
        queries.serverId = this.serverId;
      }
      if(this.token.length > 0) {
        queries.token = this.token;
      }
      if(this.selectedNotificationType.length > 0) {
        queries.ringType = this.selectedNotificationType;
      }
      if(this.priority.length > 0) {
        queries.priority = this.priority;
      }
      if(this.notificationId.length > 0) {
        queries.tamat_notification_id = this.notificationId;
      }
      if(this.locationGPS.length > 0) {
        queries.locationGPS = this.locationGPS;
      }
      if(this.locationDescription.length > 0) {
        queries.locationDescription = this.locationDescription;
      }
      if(this.phoneNumberToCall.length > 0) {
        queries.phoneNumberToCall = this.phoneNumberToCall;
      }
      if(this.isProd) {
        queries.isProd = "true";
      } else {
        queries.isProd = "false";
      }
      // if(this.actions.length > 0) {

      //   queries.actions = this.actions;
      // }

      let queryList = [];
      for (let [key, value] of Object.entries(queries)) {
        queryList.push(`${key}=${encodeURIComponent(value)}`);
      }

      return `?${queryList.join("&")}`
    },

    canSendNotification: function() {
      return this.token.length > 0 
        && this.serverId.length > 0 
        && this.recipient.length > 0 
        && this.title.length > 0 
        && this.body.length > 0
        && this.antiBotThing === "10";
    },
  },
  watch: {
    qrCodeValid(newValue) {
      if(newValue) {
        this.qrCodeVisible = true;
         this.updateQRCode(this.qrCodeData);
      } else {
        this.qrCodeVisible = false;
      }
    },
    qrCodeData(newValue) {
      if(this.qrCodeValid) {
        this.updateQRCode(newValue);
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
